import React, { useMemo } from 'react';
import { useCard } from '../../themes/cardStyles';
import { buildPaletteTheme } from '../../themes/palettes';

export const PresenceList = ({ theme, density, friends, palette, cardStyle, cardFinish }) => {
  const c = theme.colors;
  const t = theme.typography || {};
  const e = theme.effects || {};

  const tintedTheme = useMemo(
    () => buildPaletteTheme(theme, palette, cardStyle, cardFinish),
    [theme, palette, cardStyle, cardFinish]
  );
  const cardObj = useCard(tintedTheme, cardStyle, false);

  // Sort: DM first, then online, then offline
  const sorted = [...friends].sort((a, b) => {
    if (a.role === 'DM' && b.role !== 'DM') return -1;
    if (b.role === 'DM' && a.role !== 'DM') return 1;
    if (a.status === 'online' && b.status === 'offline') return -1;
    if (b.status === 'online' && a.status === 'offline') return 1;
    return 0;
  });

  return (
    <div style={{ ...cardObj, padding: '8px 14px' }}>
      {sorted.map((f, i) => (
        <div key={f.id} style={{
          display: 'flex', alignItems: 'center', gap: 10,
          padding: '8px 0',
          borderTop: i === 0 ? 'none' : `1px solid ${c.borderLight}`,
          opacity: f.status === 'offline' ? 0.55 : 1,
        }}>
          <span style={{
            width: 7, height: 7, borderRadius: 999,
            background: c.textMuted,
            opacity: 0.6,
            flex: '0 0 auto',
          }} />
          <span style={{
            flex: 1,
            fontSize: '0.92rem',
            fontFamily: t.headingFamily,
            fontWeight: 500,
            color: f.status === 'offline' ? c.textMuted : c.textPrimary,
          }}>{f.name}</span>
          {f.role === 'DM' && (
            <span style={{
              fontSize: '0.62rem',
              padding: '2px 7px',
              borderRadius: 4,
              background: `${c.warning}22`,
              color: c.warning,
              letterSpacing: '0.18em',
              fontWeight: 700,
              fontFamily: t.fontFamily,
            }}>DM</span>
          )}
        </div>
      ))}
    </div>
  );
};
